module.exports = __webpack_public_path__ + "static/media/nvd.03c3ca79.png";